import { createSelector } from 'reselect'

import { RootState } from 'redux/store';

const selectPageParameters = createSelector(
  (state: RootState) => state.page.configParameters,
  pageParameters => pageParameters
)

export default selectPageParameters
